// Environment-specific configuration
const ENV=process.env.NODE_ENV||'development';// Auth configuration
export const AUTH_CONFIG={// Authentication disabled by default in development environment, enabled in others
enabled:ENV!=='development',// Debug token for bypassing authentication when auth is manually disabled
debugToken:'dev-user-token'};// API configuration
export const API_CONFIG={baseUrl:process.env.REACT_APP_API_URL||'http://localhost:3001/api',timeout:30000// 30 seconds
};// Feature flags
export const FEATURES={enableHeyGen:true,enableKnowledgeChecks:true,enableCustomPlans:true};// Export the entire config object
export const APP_CONFIG={env:ENV,auth:AUTH_CONFIG,api:API_CONFIG,features:FEATURES};export default APP_CONFIG;